import { useState, useEffect } from 'react'
import { currencyFormatter } from './CustomUtils.js'

export default function ReportTotalsRow({ reportData, totalColumns, totalColSpan }) {
  console.log('ReportTotalsRow rendered')

  const [totals, setTotals] = useState([])

  function totalFunction(number) {
    if (number !== '') {
      return parseFloat(number) * 100
    }
    return 0
  }

  useEffect(() => {
    const workingTotals = []
    for (let totalColumn of totalColumns) {
      workingTotals[totalColumn.columnNumber] = {
        total: 0,
        formatter: totalColumn.formatter ? totalColumn.formatter : currencyFormatter().format,
        totalFunction: totalColumn.totalFunction ? totalColumn.totalFunction : number => totalFunction(number),
        finalFunction: totalColumn.finalFunction ? totalColumn.finalFunction : number => number / 100
      }
    }
    // get all the totals
    for (let row of reportData) {
      for (let col = 0; col < row.length; col++) {
        if (workingTotals[col + 1]) {
          workingTotals[col + 1].total += workingTotals[col + 1].totalFunction(row[col])
        }
      }
    }
    setTotals(workingTotals)
  }, [reportData, totalColumns])

  const columns = []
  let colSpan = totalColSpan ? totalColSpan : totalColumns[0].columnNumber
  const totalLabel = totalColumns.length > 1 ? 'Totals' : 'Total'


  // create the totals row
  for (let i = totalColumns[0].columnNumber; i <= totalColumns[totalColumns.length - 1].columnNumber; i++) {
    if (totals[i]) {
      const style = totals[i].style ? totals[i].style : { fontWeight: 'bold' }
      columns.push(<td key={i} align='right' style={style}>{totals[i].formatter(totals[i].finalFunction(totals[i].total))}</td>)
    } else {
      columns.push(<td key={i}></td>)
    }
  }

  return (
    <tr key={'totals'}>
      <td colSpan={colSpan} style={{ textAlign: 'right', fontWeight: 'bold' }}>{totalLabel}</td>
      {columns}
    </tr>
  )
}